import { useNavigate } from 'react-router-dom';

export function ChannelAvailabilityState({
  status,
  canOpenSettings = false,
  children,
}) {
  if (status?.isLoading) {
    return (
      <p className="py-6 text-center text-sm font-medium text-[#868686]">
        Checking integrations…
      </p>
    );
  }

  if (status?.isError || !status?.isReady) {
    return (
      <div className="py-4 flex flex-col items-start gap-3">
        <p className="text-sm font-medium text-[#1F2241]">
          Could not check which integrations are connected.
        </p>
        <button
          type="button"
          onClick={() => status?.refetch?.()}
          className="h-9 px-4 rounded-xl bg-primary text-white text-sm font-semibold hover:bg-primary-hover cursor-pointer"
        >
          Retry
        </button>
      </div>
    );
  }

  if (!status.email && !status.whatsapp) {
    return (
      <div className="py-4 flex flex-col items-start gap-3">
        <p className="text-sm font-medium text-[#1F2241]">
          Connect Email or WhatsApp to continue.
        </p>
        {canOpenSettings ? <SettingsButton /> : null}
      </div>
    );
  }

  return children;
}

function SettingsButton() {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate('/integrations')}
      className="h-9 px-4 rounded-xl border border-primary text-primary text-sm font-semibold hover:bg-surface-mint cursor-pointer"
    >
      Open settings
    </button>
  );
}
